import React from "react";
import { Link } from "gatsby"

function PrimaryButton(props) {
  return <Link to={props.LinkTo} className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-purple-700 hover:bg-purple-800">{props.ButtonText}</Link>;
}

export default PrimaryButton;
